/* eslint-disable */
import React, { useState, useEffect } from "react";
// for Localization
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { get_lang } from "../../../../global-functions/apiGlobal";
import Product from "../Product";

function NonProgressiveSearch({ t, i18n, userSearch }) {
  const appState = useSelector((state) => state);
  const [isSearching, setIsSearching] = useState(false);

  // Show loading state when user is typing
  useEffect(() => {
    if (userSearch !== "") {
      setIsSearching(true);
      const timer = setTimeout(() => {
        setIsSearching(false);
      }, 500);
      return () => clearTimeout(timer);
    } else {
      setIsSearching(false);
    }
  }, [userSearch]);

  return (
    <div className="col-12 p-1 prod_main_div">
      <div className="col-12 inner_prod ">
        {userSearch !== "" ? (
          isSearching ? (
            <div className="text-center mt-5">
              <h4 className="text-muted">
                {/* Searching... */}
                {t("Searching") || "Searching..."}
              </h4>
            </div>
          ) : appState.products && appState.products.length > 0 ? (
            appState.products.map((item, ind) => {
              return <Product item={item} key={ind} callingFrom="search"  />;
            })
          ) : (
            <div className="text-center mt-5">
              <h4 className="text-muted">
                {/* Product not found */}
                {t("Product not found")}
              </h4>
            </div>
          )
        ) : (
          <div className="text-center mt-5">
            <h4 className="text-muted">
              {/* Search for a product */}
              {t("Search for a product")}
            </h4>
          </div>
        )}
      </div>
    </div>
  );
}

export default withTranslation()(NonProgressiveSearch);
